import React, { Component } from 'react';
import Button from "@material-ui/core/Button";
import {
    supportDetails,
    saveOrUpdateSupportDetails, trackExport
} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { t } from '../../i18n';
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import {GreenButton} from "../common/ButtonsConstants";
import { Editor } from '@tinymce/tinymce-react';
import * as htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from 'file-saver';
import * as PropTypes from "prop-types";
import moment from "moment";
import DocumentControlHeader from "../support/DocumentControlHeader";
import * as CommonUtils from "../../util/CommonUtils";

class SupportBase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            supportId: "",
            support: null,
            content: "",
            isEdit: false,
        };
        this.editContent = this.editContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.supportDetails = this.supportDetails.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }

    editContent = () => {
        this.setState({
            isEdit: !this.state.isEdit
        });
    };

    handleEditorChange = (content) => {
        this.setState({ content });
    };

    componentDidMount() {
        this.supportDetails();
    }

    supportDetails() {
        supportDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    supportId: response.id,
                    support: response,
                    content: response[this.props.contentName]
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const request = Object.assign(this.state.support,
            {
                id: this.state.supportId,
                [ this.props.contentName ]: this.state.content
            }
        );
        console.log(request);
        saveOrUpdateSupportDetails(request)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.editContent();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        const { state } = this;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <DocumentControlHeader title={this.props.title} revision={this.props.latestRevision} support={state.support} isReadOnly={isAuditor || isViewer}>
            {
                !state.isEdit ?
                    (
                        <React.Fragment>
                            {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => { saveAs(htmlDocx.asBlob(this.toRevisionTable(state.support.latestRevisionDto) + this.props.exportTitle + state.content), this.props.exportFileName); trackExport(this.props.exportTitle); }} style={{ float: 'right' }}>{ t('support.export') }</GreenButton>}
                            <div style={{ clear: 'both' }}/>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: state.content
                                }}>
                            </div>
                            <Button
                                onClick={this.editContent}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={isAuditor || isViewer}
                            >
                                { t('support.edit') }
                            </Button>
                        </React.Fragment>
                    )
                    :
                    <React.Fragment>
                        <GreenButton
                            onClick={this.handleSubmit}
                            type="submit"
                            style={{ float: 'right' }}
                            variant="contained"
                            color="primary"
                        >
                            { t('support.save') }
                        </GreenButton>
                        <div style={{ clear: 'both' }}/>
                        <Editor
                            apiKey="y9iyidzzc5orr4c7nqrr9edoyr9on123bjjw4dfjvfoj54hu"
                            value={ state.content }
                            init={{
                                height: 900,
                                branding: false,
                                menubar: false,
                                plugins: [
                                    'advlist autolink lists link image charmap print preview anchor',
                                    'searchreplace visualblocks code fullscreen',
                                    'insertdatetime media table paste code help wordcount'
                                ],
                                toolbar:
                                    'undo redo | formatselect | bold italic backcolor | \
                                    alignleft aligncenter alignright alignjustify | \
                                    bullist numlist outdent indent | removeformat | help'
                            }}
                            onEditorChange={this.handleEditorChange}
                        />
                    </React.Fragment>
            }
            <NotificationContainer/>
            </DocumentControlHeader>
        </div>;
    }

    /*
                        title={
                        <span style={{color: "darkblue"}}>
                            <p><b>{isRevision && `P ${revision.number}`} {revision.title}</b></p>
                        </span>
                    }
                    subheader={
                        isRevision &&
                        <span>
-                            <p>Author: {revision.author}</p>
-                            <p>Approved for suitability and adequacy by: {revision.approvedBy} on {moment(revision.date).format('DD/MM/YYYY')}</p>
+                            <p>{ t('context.common.author') }: {revision.author}</p>
+                            <p>{ t('context.common.approvedFor') }: {revision.approvedBy} { t('context.common.on') } {moment(revision.date).format('DD/MM/YYYY')}</p>
                        </span>
                    }
     */
    toRevisionTable(revision) {
        return '<table style="width:100%">' +
            '<tr>' +
                '<td><b>' + t('context.common.revision') + ' ' + revision.number + ' ' + t('context.common.author') + ': ' + revision.author + '</b></td>' +
            '</tr>' +
            '<tr>' +
                '<td>' + t('context.common.approvedFor') + ': ' + revision.approvedBy + ' ' + t('context.common.on') + ' ' + moment(revision.date).format('DD/MM/YYYY') + '</td>' +
            '</tr>' +
        '</table>';
    }
}

SupportBase.propTypes = {
    contentName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    exportTitle: PropTypes.string.isRequired,
    exportFileName: PropTypes.string.isRequired,
    latestRevision: PropTypes.object.isRequired,
};

export default SupportBase;
